import { List, Skeleton } from 'antd';
import React from 'react';

const listData = Array.from({ length: 3 }).map((_, i) => ({
  href: 'https://ant.design',
  title: `loader ${i}`,
  avatar: 'https://joeschmoe.io/api/v1/random',
  description:
    'Ant Design, a design language for background applications, is refined by Ant UED Team.',
  content:
    'We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.',
}));

const ListLoader: React.FC<{ loading: boolean }> = ({ loading }) => {
  return (
    <List
      itemLayout="vertical"
      size="large"
      dataSource={listData}
      renderItem={(item) => (
        <List.Item key={item.title}>
          <Skeleton loading={loading} active>
            <List.Item.Meta
              title={<a href={item.href}>{item.title}</a>}
              // description={item.description}
            />
            {item.content}
          </Skeleton>
        </List.Item>
      )}
    />
  );
};

export default ListLoader;
